import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'Components/Button';
import CircleXIcon from 'Components/icons/CircleXIcon';
import SmallButton from 'Components/Button/SmallButton';
import OutsideClickHandler from 'Components/OutsideClickHandler';

const ConfirmationModalPopup = (props) => {
  const {
    actionText,
    actionTextOpt1,
    actionTextOpt2,
    cancelButtonText,
    dangerAction,
    dangerButtonText,
    direction,
    title,
    toggleModal,
  } = props;

  const modalClasses = classnames('confirmation-modal', {
    'modal-down': direction === 'down',
    'modal-page-center': direction === 'centered',
    'modal-page-center overlay-center': direction === 'overlay-centered',
  });

  const hasIcon = direction === 'centered' || direction === 'overlay-centered';
  const hasHeader = !hasIcon;

  const buttonWrapperClasses = classnames('button-wrapper', {
    'button-wrapper-gray': hasHeader,
  });

  const cancelButtonCategories = classnames('link', {
    small: hasHeader,
  });
  const actionButtonCategories = classnames({
    small: hasHeader,
  });

  return (
    <OutsideClickHandler onClickOutside={toggleModal}>
      <div className={modalClasses}>
        {
          hasHeader && (
          <span className="headline-wrapper">
            <span className="headline">{title}</span>
          </span>)
        }
        {
          hasIcon && (
          <span className="icon-wrapper">
            <CircleXIcon />
          </span>)
        }
        <div className="content-wrapper">
          {
            hasIcon && (
              <h2>{title}</h2>
            )
          }
          <span className="content">{actionText}</span>
          <span className="content content-bold">{actionTextOpt1}</span>
          <span className="content">{actionTextOpt2}</span>
        </div>
        <div className={buttonWrapperClasses}>
          {/* Buttons with two categories can be built with the button component itself rather than a custom */}
          <Button
            category={cancelButtonCategories}
            action={toggleModal}
            extraClass="ignore-option-box-popup"
          >
            {cancelButtonText}
          </Button>
          <Button
            category={actionButtonCategories}
            action={dangerAction}
            extraClass="delete ignore-option-box-popup"
          >
            {dangerButtonText}
          </Button>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

ConfirmationModalPopup.propTypes = {
  actionText: PropTypes.string.isRequired,
  actionTextOpt1: PropTypes.string,
  actionTextOpt2: PropTypes.string,
  cancelButtonText: PropTypes.string.isRequired,
  dangerAction: PropTypes.func.isRequired,
  dangerButtonText: PropTypes.string.isRequired,
  direction: PropTypes.string,
  title: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

ConfirmationModalPopup.defaultProps = {
  direction: '',
  actionTextOpt1: null,
  actionTextOpt2: null,
};

export default ConfirmationModalPopup;
